// src/pages/superadmin/SessionManagementPage.jsx
import React from 'react';
import Layout from '../../components/Layout';
import SuperAdminSessionManagement from '../../components/SuperAdminSessionManagement';

const SessionManagementPage = () => {
  return (
    <Layout role="superadmin">
      <div className="container mx-auto p-6">
        <h1 className="text-3xl font-bold mb-6">Session Management</h1>
        <SuperAdminSessionManagement />
      </div>
    </Layout>
  );
};

export default SessionManagementPage;
